export default __webpack_public_path__ + "static/media/xyz.c42deff6.svg";